'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Show = exports.Show = function () {
  function Show() {
    _classCallCheck(this, Show);

    this.node = null;
  }

  _createClass(Show, [{
    key: 'bind',
    value: function bind(node) {
      this.node = node;
    }
  }, {
    key: 'unbind',
    value: function unbind(node) {
      this.node = null;
    }
  }, {
    key: 'update',
    value: function update(value) {
      this.node.style.display = value ? '' : 'none';
    }
  }]);

  return Show;
}();

var Hide = exports.Hide = function () {
  function Hide() {
    _classCallCheck(this, Hide);

    this.node = null;
  }

  _createClass(Hide, [{
    key: 'bind',
    value: function bind(node) {
      this.node = node;
    }
  }, {
    key: 'unbind',
    value: function unbind(node) {
      this.node = null;
    }
  }, {
    key: 'update',
    value: function update(value) {
      this.node.style.display = !value ? '' : 'none';
    }
  }]);

  return Hide;
}();